import { useDesktopUpdater } from '../hooks/useDesktopUpdater';
import { useT } from '../i18n';

/**
 * ANX-092 — узкая полоса под шапкой (как OfflineBanner): «Доступна версия
 * X — Обновить». Видна только в desktop-приложении при наличии обновления.
 * Установка стартует ТОЛЬКО по клику (приложение скачает, поставит и
 * перезапустится само); тихой авто-установки нет — она валила старт.
 */
export function UpdateBanner() {
  const { availableVersion, installing, install } = useDesktopUpdater();
  const t = useT();

  if (availableVersion === null) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      className="bg-indigo-50 text-indigo-900 text-xs text-center py-1 border-b border-indigo-200 flex items-center justify-center gap-2"
    >
      <span>{t('desktop.update.available', { version: availableVersion })}</span>
      <button
        type="button"
        disabled={installing}
        onClick={install}
        className="rounded bg-indigo-600 px-2 py-0.5 text-white hover:bg-indigo-700 disabled:opacity-60"
      >
        {installing ? t('desktop.update.installing') : t('desktop.update.install')}
      </button>
    </div>
  );
}
